<template>
    <div>
        <div class="card shadow mb-5">
            <div class="card-header">Saisie des temps</div>

            <b-card-body>
                <div class="row">
                    <div class="col-4">
                        <input-date-select />
                    </div>
                </div>

                <entry-create :key="key" @entry-created="getData" />
                <b-alert variant="danger" :show="hasError">
                    {{ errorMessage }}
                </b-alert>
                <div v-for="entry in timeSheets" :key="'timeSheet' + entry.id">
                    <entry-edit
                        :entry="entry"
                        @entry-is-deleted="getData"
                        @duration-has-changed="getData"
                    />
                </div>
                <b-alert
                    variant="secondary"
                    class="p-2 mt-3"
                    :show="dateActivityDuration > 0"
                >
                    Total journée : {{ dateActivityDuration.toFixed(2) }} heures
                </b-alert>
            </b-card-body>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import InputDateSelect from './InputDateSelect.vue'
import EntryCreate from './EntryCreate.vue'
import EntryEdit from './EntryEdit.vue'

export default {
    name: 'TimeInput',

    components: {
        EntryEdit,
        InputDateSelect,
        EntryCreate,
    },

    data() {
        return {
            timeSheets: [],
            key: '',
        }
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'time-sheets-input')
        this.$store.commit('timeSheetsVM/RESET_ERROR')
        this.getData()
    },

    methods: {
        async getData() {
            const currentYear = this.$moment(this.activityDate).format('Y')
            const currentMonth = this.$moment(this.activityDate).format('MM')
            const currentDay = this.$moment(this.activityDate).format('DD')
            try {
                const response = await axios.get(
                    `/time-sheets/${currentYear}/${currentMonth}/${currentDay}`
                )
                this.timeSheets = response.data.data
                this.calculateDateActivityDuration()
                this.key = Date.now()
            } catch (error) {
                console.log(error)
            }
        },

        calculateDateActivityDuration() {
            let duration = 0
            this.timeSheets.forEach((item) => {
                duration += item.activity_duration
            })
            this.$store.commit(
                'timeSheetsVM/SET_DATE_ACTIVITY_DURATION',
                duration
            )
        },
    },

    computed: {
        ...mapState({
            activityDate: (state) => state.timeSheetsVM.currentDate,
            dateActivityDuration: (state) =>
                state.timeSheetsVM.dateActivityDuration,
            hasError: (state) => state.timeSheetsVM.hasError,
            errorMessage: (state) => state.timeSheetsVM.errorMessage,
        }),
    },
}
</script>

<style scoped></style>
